import {Button} from "antd";
import React, {useState, useEffect} from "react";
import {
    StyledModal,
    DocumentContainer,
    DocumentIframe,
    LoadingContainer,
    StyledSpin,
    ErrorMessage,
    FooterContent,
    DescriptionText,
    ButtonGroup,
    DownloadButton
} from "./DocumentModal.styles";

export const DocumentModal = ({
    visibility,
    onCancel,
    documentUrl,
    title = "Belge Görüntüleyici",
    onApprove,
    isNeedForApproval,
    isApproved,
    isApproveButtonDisabled,
    description
}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [iframeUrl, setIframeUrl] = useState("");

    useEffect(() => {
        if (visibility && documentUrl) {
            setIsLoaded(false);
            setHasError(false);
            setIsLoading(true);

            const isPdf = documentUrl.toLowerCase().endsWith(".pdf");
            if (isPdf) {
                setIframeUrl(documentUrl);
            } else {
                const randomParam = `cacheBust=${new Date().getTime()}`;
                setIframeUrl(
                    `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                        documentUrl
                    )}&embedded=true&${randomParam}`
                );
            }
        }
    }, [visibility, documentUrl]);

    const handlePrint = () => {
        window.print();
    };

    return (
        <StyledModal
            title={title}
            visible={visibility}
            onCancel={onCancel}
            destroyOnClose={true}
            footer={[
                <FooterContent key="footer">
                    {description && <DescriptionText>{description}</DescriptionText>}
                    <ButtonGroup>
                        {documentUrl && (
                            <DownloadButton
                                key="download"
                                href={documentUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                            >
                                İndir
                            </DownloadButton>
                        )}
                        {isNeedForApproval && isApproved !== true && !hasError && isLoaded && (
                            <Button
                                key="approve"
                                type="primary"
                                onClick={onApprove}
                                disabled={isApproveButtonDisabled}
                            >
                                Onayla
                            </Button>
                        )}
                        <Button key="close" onClick={onCancel}>
                            Kapat
                        </Button>
                    </ButtonGroup>
                </FooterContent>
            ]}
            width={920}
        >
            {documentUrl ? (
                <DocumentContainer>
                    {isLoading && (
                        <LoadingContainer>
                            <StyledSpin size="large" tip="Belge yükleniyor..." />
                        </LoadingContainer>
                    )}
                    <DocumentIframe
                        key={iframeUrl}
                        src={iframeUrl}
                        style={{
                            visibility: isLoaded ? "visible" : "hidden"
                        }}
                        title="Document Viewer"
                        onLoad={() => {
                            setIsLoaded(true);
                            setIsLoading(false);
                            setHasError(false);
                        }}
                        onError={() => {
                            setHasError(true);
                            setIsLoading(false);
                        }}
                    />
                </DocumentContainer>
            ) : (
                <LoadingContainer>
                    <StyledSpin size="large" tip="Yükleniyor..." />
                </LoadingContainer>
            )}

            {hasError && <ErrorMessage>Belge yüklenemedi. Lütfen tekrar deneyin.</ErrorMessage>}
        </StyledModal>
    );
};
